import { useEffect } from "react";
import AboutItems from "../components/AboutItems";
import Contact from "../components/Contact";
import Header from "../components/Header";
import Navigation from "../components/Navigation";
import Team from "../components/Team";
import useTitle from "@nooks/use-title";

const headerContent = {
    heading: "about\ncarryvilly",
    subheading: false,
    linkBtn: false
}

function About({userObj, isLoggedIn}){
    useTitle("캐리빌리를 소개합니다!")
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    return (
        <div>
            <Navigation userObj={userObj} isLoggedIn={isLoggedIn} />
            <Header content={headerContent} />
            <AboutItems />
            <Team />
            <Contact />
        </div>
    )
}

export default About;